import Vue from 'vue';

interface DataProp {
  id: number;
  [key: string]: any;
}

interface EntityPropPayload {
  id: number;
  entity: string;
  propToUpdate: string;
  value: any;
}

export default {
  CLEAN_STATE(state: any, entity: string) {
    state[entity] = {};
  },
  SET_NORMALIZED_DATA(state: any, entities: object) {
    // for this mutation to work, state objects at ./state.ts
    // must have same names as normalized entities
    for (const key of Object.keys(entities)) {
      state[key] = { ...state[key], ...entities[key] };
    }
  },
  UPDATE_ENTITY(
    state: any,
    { entity, data }: { entity: string; data: DataProp },
  ) {
    state[entity] = {
      ...state[entity],
      [data.id]: data,
    };
  },
  UPDATE_ENTITY_PROP(state: any, payload: EntityPropPayload) {
    const { id, entity, propToUpdate, value } = payload;
    state[entity] = {
      ...state[entity],
      [id]: {
        ...state[entity][id],
        [propToUpdate]: value,
      },
    };
  },
  DELETE_ENTITY(state: any, { entity, id }: { entity: string; id: number }) {
    Vue.delete(state[entity], id);
  },
};
